<template>
  <Btn
    class="BtnReviewWatch light"
    :class="{ success: isWatched }"
    icon="eye"
    :isLoading="isTogglingWatch"
    @click="toggleWatching">
    {{ isWatched ? $t('watching') : $t('watch') }}
  </Btn>
</template>

<script>
import { actions } from '@utils'

export default {
  props: {
    reviewExternal: { type: Object, required: true },
  },
  data() {
    return {
      isTogglingWatch: false,
    }
  },
  computed: {
    isWatched() {
      return !!this.reviewExternal.watchedSince
    },
  },
  methods: {
    async toggleWatching() {
      const { watchedSince } = await this.$wrap(
        () => this.PATCH_REVIEW_EXTERNAL({
          id: this.reviewExternal.id,
          watchedSince: this.isWatched ? null : new Date(),
        }),
        'isTogglingWatch',
      )

      this.$up('reviewExternal.watchedSince', watchedSince)
    },
    ...actions('PATCH_REVIEW_EXTERNAL'),
  },
}
</script>

<style lang="scss">
.BtnReviewWatch {
}
</style>

<i18n>
{
  "en": {
    "watch": "Watch",
    "watching": "Watching"
  }
}
</i18n>
